import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_POWERPOINT_REPORT,
  DELETE_POWERPOINT_REPORT,
  CREATE_POWERPOINT_REPORT,
  SG_FETCH_POWERPOINT_REPORT,
  FETCH_POWERPOINT_REPORT,
//   GET_POWERPOINT_REPORT_STATUS,
  POWERPOINT_REPORTS_PENDING,
} from "constants/actions";
import * as api from "constants/api";

function* fetchPowerPointReports(action) {
  try {
    yield put({ type: POWERPOINT_REPORTS_PENDING });
    const response = yield call(api.GET_POWERPOINT_REPORTS, action.payload);
    yield put({ type: GET_POWERPOINT_REPORT, payload: response.data });
  } catch (error) {
    console.error("Error fetching PowerPoint reports:", error);
  }
}

function* fetchPowerPointReportDetails(action) {
  try {
    yield put({ type: POWERPOINT_REPORTS_PENDING });
    const response = yield call(api.FETCH_POWERPOINT_REPORT, action.payload);
    yield put({ type: FETCH_POWERPOINT_REPORT, payload: response.data });
  } catch (error) {
    console.error("Error fetching PowerPoint report details:", error);
  }
}

function* createPowerPointReport(action) {
  try {
    yield put({ type: POWERPOINT_REPORTS_PENDING });
    const response = yield call(api.ADD_POWERPOINT_REPORT, action.payload);
    yield put({ type: CREATE_POWERPOINT_REPORT, payload: response.data });
  } catch (error) {
    console.error("Error creating PowerPoint report:", error);
  }
}

function* deletePowerPointReport(action) {
  try {
    yield put({ type: POWERPOINT_REPORTS_PENDING });
    yield call(api.DELETE_POWERPOINT_REPORT, action.payload);
    yield put({ type: DELETE_POWERPOINT_REPORT, payload: action.payload.id });
  } catch (error) {
    console.error("Error deleting PowerPoint report:", error);
  }
}

export default function* presentationReportSaga() {
  yield takeLatest("SG_GET_POWERPOINT_REPORT", fetchPowerPointReports);
  yield takeLatest("SG_CREATE_POWERPOINT_REPORT", createPowerPointReport);
  yield takeLatest(SG_FETCH_POWERPOINT_REPORT, fetchPowerPointReportDetails);
  yield takeLatest("SG_DELETE_POWERPOINT_REPORT", deletePowerPointReport);
}